import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayersIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, checkoutNote, heroBadges, heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-138" data-mp="4mi3tby6fqf0">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-139" data-mp="129h5y27n1qka">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.16em] text-blue-600 md:text-lg" data-id="element-140" data-mp="127ec173d7daa">
          <LayersIcon className="h-5 w-5" aria-hidden="true" data-id="element-141" data-mp="nekmesudpgrw" />
          {brand.name}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl font-display text-[2.5rem] font-extrabold leading-[1.04] tracking-tight text-ink sm:text-5xl md:text-6xl" data-id="element-142" data-mp="3cz5x6h3fwa2z">
          {brand.promise}
          <br data-id="element-143" data-mp="399bctsb4jly3" />
          <span className="text-blue-600" data-id="element-144" data-mp="399tc6xt32ga8">{brand.promiseAccent}</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.14,
        ease
      }} src={heroImage} alt="Atlas Kinesio-Visual: los 100 mapas maestros impresos junto a los 6 bonos incluidos" className="mx-auto mt-10 w-full max-w-2xl" width={1240} height={1240} data-id="element-145" data-mp="3e84mf9naissz" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.2,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-146" data-mp="2vjga3c2vhvst">
          <p className="text-xl leading-relaxed text-blue-900/80 md:text-2xl" data-id="element-147" data-mp="2lmv3wnf4aene">{brand.subtitle}</p>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-blue-900/70" data-id="element-148" data-mp="s44e5chl11cm">
            {heroBadges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5" data-id="element-149" data-mp="icrnupbfmj8p">
                <CheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-150" data-mp="de6ost7x25lu" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-151" data-mp="1ayjh1d70le5q">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-152" data-mp="161jaz2a60bem">
              Quiero el Atlas completo ahora
            </CtaButton>
            <p className="mx-auto mt-3 max-w-xl text-sm text-blue-900/60" data-id="element-153" data-mp="11152xk8kd1gl">{checkoutNote}</p>
          </div>

          <p className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-blue-900/70" data-id="element-154" data-mp="x0uwy7krub1q">
            <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-155" data-mp="3lu9y13eog2ca" />
            Garantía de 7 días o te devolvemos tu dinero
          </p>
        </motion.div>
      </div>
    </section>;
}